import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Footer() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const resources = [
    { label: 'CSSBuy Spreadsheet', href: '/' },
    { label: 'Products', href: '/products' },
    { label: t('nav_guides'), href: '/#articles' },
    { label: t('review_h2').split(':')[0], href: '/article/cssbuy-review' },
    { label: t('shipping_h2').split(':')[0], href: '/article/cssbuy-shipping-cost' },
    { label: t('coupon_h2').split(':')[0], href: '/article/cssbuy-coupon' },
    { label: t('nav_safety'), href: '/#how-it-works' },
    { label: t('nav_faq'), href: '/faq' },
  ];

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <a href="/" className="font-heading text-xl font-semibold text-foreground-900 tracking-tight">cssbuybr.living</a>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              {t('hero_desc').substring(0, 120)}...
            </p>
            <div className="mt-4 flex gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap">
                {t('cta_cssbuy_spreadsheet')}
              </a>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wide">{t('footer_resources')}</h3>
            <ul className="mt-4 space-y-2.5">
              {resources.map((r) => (
                <li key={r.label}>
                  <a href={r.href} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">{r.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wide">{t('footer_categories')}</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.name}>
                  <a href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors">
                    {currentLang === 'pt' ? cat.name : currentLang === 'en' ? cat.nameEn : cat.nameDe}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-10 pt-8 border-t border-background-200/70">
          <p className="text-xs text-foreground-400 leading-relaxed text-center">{t('footer_disclaimer_text')}</p>
          <p className="mt-3 text-xs text-foreground-400 text-center">{t('footer_copyright')}</p>
        </div>
      </div>
    </footer>
  );
}